<template>
  <div class="word_pk_page">
    <div class="read_content">
      <div class="read_content_hd">
        <div class="navigation">
          <div class="left">
            <div>&nbsp;</div>
            <div style="display: none" class="back-btn" @click="backRoute"></div>
          </div>
          <div class="center">{{ title }} - {{level_title}}</div>
          <div class="right">
            <div class="select_level_btn" @click="to_levels_page">选择难度</div>
          </div>
        </div>
      </div>
      <div class="read_content_bd">
        <div class="items">
          <div class="card_wrap" v-for="(item,index) in items" v-bind:key="index">
            <div class="card" @click="to_detail(item.id)">
              <div>
                <img :src="item.img">
              </div>
              <div class="text">{{ item.ch_title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFamousReadList } from '../../services'

export default {
  name: 'famous_read_index',
  components: {},
  data() {
    return {
      level_title:'',
      title: '名著阅读',
      items: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    to_detail(id) {
      this.$router.push({
        path: '/famous_read/book',
        query: {
          book_id:id,
        }
      })
    },
    to_levels_page(){
      this.$router.push({
        path: '/famous_read/levels',
        query: {}
      })
    },
    async init() {

      getFamousReadList({
        level_id:this.$route.query.level_id,
      }).then((res)=>{
        this.items = res.data.list;
        this.level_title=res.data.level.title;
      });
    },
    backRoute() {
      this.$router.replace({
        path: '/'
      })
    }
  },
}
</script>
<style lang="less" scoped>
.word_pk_page {
  display: block;
  height: 100%;
  width: 100%;
}

.read_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-size: 1620px 817px;
  background: url(~assets/lvbg.png) no-repeat center center;
}

.read_content_hd {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.select_level_btn{
  font-size: 1rem;
  padding:.25rem .56rem;
  border-radius: .3rem;
  background-color: #fff;
}

.ui-tab-content {
  display: block;
  height: 100%;
  width: 100%;
}

.navigation {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  width: 960px;
  height: 60px;
  text-align: center;
  padding: 0 40px;

  .left {
    flex: 1;
  }

  .center {
    flex: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .right {
    flex: 1;
    display: flex;
    text-align: right;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
  }
}

.read_content_bd {
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}



.back-btn {
  display: block;
  width: 30px;
  height: 27px;
  background: url(~assets/word/back-icon.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}


.items {
  display: block;
  width: 900px;
  margin: 1rem auto 0;

  .card_wrap {
    display: block;
    float: left;
    width: 20%;
    padding: .5rem;
    box-sizing: border-box;

    &.active {
      .card {
        border-color: #27BF95;
        background: #27BF95;

        .text {
          //color: #27BF95;
          color: #fff;
        }

        .secondary-text {
          opacity: .8;
          //color: #27BF95;
          color: #fff;
        }
      }
    }

    .card {
      img {
        border-radius: 5px;
        width: 100%;
        height: 200px;
      }

      .text {
        height: 60px;
        padding: .5rem;
        width: 100%;
        text-align: left;
        display: block;
      }

      width: 100%;
      cursor: pointer;
      background: #fff;
      padding: 0;
      border-radius: 5px;
      display: flex;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;

      .text {
        font-size: 1rem;
      }

      .secondary-text {
        color: rgba(0, 0, 0, .5);
        font-size: .8rem;
      }
    }
  }
}

.submit-btn {
  display: inline-block;
  min-width: 140px;
  height: 46px;
  line-height: 46px;
  margin-left: .5rem;

  .ui-btn {
    padding: 0;
  }
}

</style>